export default __webpack_public_path__ + "static/media/type.a18a520a.svg";